import {
  SELECT_PAYMENT_OPTION,
  BRAINTREEE_PAYMENT_DATA_UPDATE,
  PURCHASE_ORDER_PAYMENT_DATA_UPDATE,
  UPDATING_EBIZ_CHARGE_WEB_FORM_URL_ASYNC,
  UPDATE_EBIZ_CHARGE_WEB_FORM_URL,
  EBIZ_CHARGE_WEB_FORM_URL_ERROR,
  fetchJson,
} from '../../GlobalStateContainer';
import { 
  notifyError,
  notifyCompleteCheckoutError } from '../UserMessaging';
import { translateResourceString } from '../../../util/translationUtility';

/* PAYMENT METHOD */

export function selectPaymentOption(paymentMethodId, displayName) {
  return { type: SELECT_PAYMENT_OPTION, paymentMethodId, displayName }
}

export function updateBraintreePaymentData(payload) {
  return { type: BRAINTREEE_PAYMENT_DATA_UPDATE, payload }
}

export function updatePurchaseOrderNumber(number) {
  return { type: PURCHASE_ORDER_PAYMENT_DATA_UPDATE, number }
}

export function notifyRefreshingEBizChargeFormUrl() {
  return { type: UPDATING_EBIZ_CHARGE_WEB_FORM_URL_ASYNC }
}

function onFetchEBizChargeWebFormUrlSuccess(payload) {
  return { type: UPDATE_EBIZ_CHARGE_WEB_FORM_URL, payload }
}

function onFetchEBizChargeWebFormUrlError(diagMsg, dispatch) {
  dispatch(notifyError(translateResourceString("/Checkout/PaymentInformation/EBizCharge/FailedToLoad"), diagMsg))
  return {type: EBIZ_CHARGE_WEB_FORM_URL_ERROR };
}

const fetchEBizChargeWebFormUrlSpec = {
  endpoint: (state) => state.constants.navigation.eBizChargeWebFormUrlEndpoint,
  init: { method: 'POST', credentials: 'same-origin' },
  notify: notifyRefreshingEBizChargeFormUrl,
  extract: (response) => response.json(),
  onSuccess: onFetchEBizChargeWebFormUrlSuccess,
  onError: (diagMsg, data, dispatch) => onFetchEBizChargeWebFormUrlError(diagMsg, dispatch),
}

export const fetchEBizChargeWebFormUrl = fetchJson(fetchEBizChargeWebFormUrlSpec)

export function handleEBizChargePayment(payload) {
  return (dispatch, getState) => {
    const state = getState();
    const orderConfirmationUrl = state.constants.navigation.orderConfirmationUrl;

    if (payload.Success && typeof window !== 'undefined' && typeof window.location !== 'undefined') {
        if(!payload.OrderNumber) {
          dispatch(notifyCompleteCheckoutError(translateResourceString("/Checkout/PaymentInformation/EBizCharge/PaymentAcceptedButNotProcessed")));
        } else {
          const url = new URL(orderConfirmationUrl, window.location.origin);
          url.searchParams.append('orderNumber', payload.OrderNumber);
          window.location.href = url.toString();
        }
    } else if(!!payload.Declined) {
      dispatch(notifyCompleteCheckoutError(translateResourceString("/Checkout/PaymentInformation/EBizCharge/PaymentDeclined")));
    } else {
      dispatch(notifyCompleteCheckoutError(translateResourceString("/Checkout/PaymentInformation/EBizCharge/PaymentError")));
    }
  }
}
